import React from 'react';

import {
  appEvents,
  pagination
} from 'modules';

import styled from '@emotion/styled';
import { Box } from '@mui/material';
import * as dataService from './dataService';



const ContainerBox = styled(Box)(({ theme }) => ({
  overflowX: 'scroll'
}));

export interface IProps {
  onChangeLoading: (loading: boolean) => void;
}

export const FC: React.FC<IProps> = props => {
  const control = pagination.useListPageControl({});
  const {
    data,
    fnRefetch
  } = dataService.useQuery(control.paginationInput);
  const params = pagination.useStandardPaginationParams({
    page: data.page,
    control
  });



  React.useEffect(() => {
    const subscription = appEvents
      .observable()
      .subscribe(appEvent => {
        if (appEvent?.type === 'modal' && appEvent.args === 'close') {
          fnRefetch();
        }
      });

    return () => subscription.unsubscribe();
  }, [fnRefetch]);



  return (
    <ContainerBox>
      <pagination.PaginatedTable.FC
        data={data.page.nodes}
        paginationParams={params}
        rowActions={[
          {
            label: 'Edit access pass',
            fnAction: id => {
              appEvents.broadcast({
                type: 'modal',
                args: {
                  type: 'editAccessPass',
                  accessPassId: id
                }
              });
            }
          }
        ]}
        columnDefs={[
          {
            label: 'Email',
            fnRenderCell: row => row.email
          },
          {
            label: 'Start Date',
            fnRenderCell: row => row.startDate.format('YYYY-MM-DD')
          },
          {
            label: 'End Date',
            fnRenderCell: row => row.endDate.format('YYYY-MM-DD')
          },
          {
            label: 'Note',
            fnRenderCell: row => row.note
          }
        ]}
      />
    </ContainerBox>
  );
};
